import { Component } from '@cms-max/medicare-api-sdk'
import { Card as SettingCard } from 'components/Card/Card'
import { CardStack, CardStackItem } from 'components/CardStack/CardStack'
import { useTranslation } from 'react-i18next'

type EasyPayBankAccountCardProps = {
  accountNumber: string,
  disableEdit?: boolean
}
export function EasyPayBankAccountCard ({
  accountNumber,
  disableEdit
}: EasyPayBankAccountCardProps) {
  const { t } = useTranslation('easyPaySummary')

  return (
    <CardStack>
      <CardStackItem>
        <SettingCard
          title={t('bankInfo.accountNumber')}
          buttonText={t('bankInfo.changeBtn')}
          buttonClass="my-u-whitespace-nowrap"
          buttonCallbackOrHref={`/premiums/easy-pay/edit`}
          displayValue={accountNumber}
          disableEdit={disableEdit}
          buttonSiteActivityProps={{
            core: {
              component: Component.EasyPay,
              elementId: 'premiums_easypaylanding_changebank_click',
              coreClickData: {
                linkText: t('bankInfo.changeBtn'),
                linkUrl: `/premiums/easy-pay/edit`
              }
            }
          }}
          headingLevel='3'
        />
      </CardStackItem>
    </CardStack>
  )
}
